import moment from 'moment';

const LEGACY_ESTIMATE_STATUS_VALUES = new Set([
  'Created',
  'Sent to Customer',
  'Exported to QB',
  'Not Created',
]);

const normalizeString = (value: unknown): string => String(value || '').trim();

const isLegacyEstimateStatus = (value: string): boolean =>
  LEGACY_ESTIMATE_STATUS_VALUES.has(value);

const formatEstimateStatusDate = (value: unknown): string => {
  if (!value) return '';
  const parsed = moment(value as any);
  return parsed.isValid() ? parsed.format('MM/DD/YY') : '';
};

export const getReadOnlyEstimateSummary = ({
  draperyOrder,
  draperyOrderSummary,
}: {
  draperyOrder?: any;
  draperyOrderSummary?: any;
}) => {
  const summary = draperyOrder?.estimateStatusSummary || {};
  const legacyEstimateJson = draperyOrderSummary?.estimateJson || {};
  const legacyRawNumber = normalizeString(legacyEstimateJson.num);
  const status =
    normalizeString(summary.status) ||
    normalizeString(draperyOrder?.estimateStatus) ||
    (isLegacyEstimateStatus(legacyRawNumber) ? legacyRawNumber : '') ||
    normalizeString(legacyEstimateJson.status) ||
    'Not Created';
  const isNotCreated = status.toLowerCase() === 'not created';
  const estimateNumber =
    normalizeString(summary.estimateNumber) ||
    normalizeString(summary.qbEstimateNumber) ||
    normalizeString(draperyOrder?.qbEstimateNumber) ||
    normalizeString(draperyOrder?.estimateNumber) ||
    (!isLegacyEstimateStatus(legacyRawNumber) ? legacyRawNumber : '');
  const statusDate = isNotCreated
    ? ''
    : formatEstimateStatusDate(
        summary.statusDate ||
          draperyOrder?.estimateDate ||
          draperyOrder?.estimateDateSent ||
          legacyEstimateJson.dateSent
      );

  return {
    status,
    estimateNumber,
    statusDate,
  };
};
